// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  backend: 'https://dev.api.ventas.citylok.com/api',
  backend_v2: "https://dev.apiv2.citylok.com/api",
  assets: 'https://dev.apiv2.citylok.com/assets/images/',
  events_img: 'https://dev.apiv2.citylok.com/events_images/',
  uri_redirect_fail_login: 'https://v2.citylok.com',
  debug: false,
};
